//  _        _      _         _
// | |  _  _| |_  _| |__ _  _| |__ _  _
// | |_| || | | || | '_ \ || | '_ \ || |
// |____\_,_|_|\_,_|_.__/\_,_|_.__/\_,_|
//
// Copyright © Lulububu Software GmbH - All Rights Reserved
// https://lulububu.de
//
// Unauthorized copying of this file, via any medium is strictly prohibited!
// Proprietary and confidential.

import React         from 'react';
import { useState }  from 'react';
import { useRef }    from 'react';
import { useEffect } from 'react';

import classNames     from 'classnames';
import { useHistory } from 'react-router';
import styled         from 'styled-components';

import { svgColor }       from '@helper/StyledMixins';
import useAppTheme        from '@hooks/AppTheme';
import useNavigationItems from '@hooks/NavigationItems';
import Button             from '@stateless/atomic/Button';
import ButtonType         from '@stateless/atomic/Button/ButtonType';
import Icon               from '@stateless/atomic/Icon';
import IconType           from '@stateless/atomic/Icon/IconType';

import styles from './styles.module.scss';

const MobileMenuContentWrapper = styled.div`
    background-color: ${(props) => props.theme.primaryColor} !important;
`;

/* eslint-disable rulesdir/no-repeatedly-props-use-constant */
// eslint-disable-next-line rulesdir/no-shortcut-variable-name
const MobileMenuItemWrapper = styled.li`
    ${(props) => svgColor(props.theme.textColor)}
    &:hover
    {
        background: ${(props) => props.theme.backgroundColor} !important;
        color:      ${(props) => props.theme.secondaryColor} !important;
    }

    &:hover,
    &.active
    {
        ${(props) => svgColor(props.theme.secondaryColor)}
        color: ${(props) => props.theme.secondaryColor} !important;
    }
`;
/* eslint-enable rulesdir/no-repeatedly-props-use-constant */

const MobileMenu = () => {
    const [open, setOpen]                            = useState(false);
    const reference                                  = useRef(null);
    const history                                    = useHistory();
    const { navigationItems, bottomNavigationItems } = useNavigationItems(history);
    const appTheme                                   = useAppTheme();
    const handleClickOutside                         = (event) => {
        if (
            reference.current &&
            !reference.current.contains(event.target)
        ) {
            setOpen(false);
        }
    };

    useEffect(() => {
        document.addEventListener('click', handleClickOutside, true);

        return () => {
            document.removeEventListener('click', handleClickOutside, true);
        };
    }, []);

    function onMobileMenuToggleClicked() {
        setOpen((current) => !current);
    }

    function renderDashboardItems(items) {
        return items.map((item) => {
            const { route, isActive, onClick, iconType, text } = item;

            return (
                <MobileMenuItemWrapper
                    key={route}
                    className={classNames(
                        styles.mobileMenuItem,
                        {
                            'active': isActive,
                        },
                    )}
                    onClick={onClick}
                >
                    <Icon
                        iconType={iconType}
                    />
                    <span>
                        {text}
                    </span>
                </MobileMenuItemWrapper>
            );
        });
    }

    return (
        <nav
            className={classNames(
                styles.mobileMenu,
                {
                    [styles.open]: open,
                },
            )}
            ref={reference}
        >
            <div className={styles.mobileMenuHeader}>
                <Button
                    customColorLeft={appTheme?.textColor}
                    onClick={onMobileMenuToggleClicked}
                    type={ButtonType.icon}
                    iconLeft={IconType.menu}
                />
            </div>
            <MobileMenuContentWrapper
                className={styles.mobileMenuContent}
            >
                <ul>
                    {renderDashboardItems(navigationItems)}
                </ul>
                <ul>
                    {renderDashboardItems(bottomNavigationItems)}
                </ul>
            </MobileMenuContentWrapper>
        </nav>
    );
};

export default MobileMenu;
